module.exports = __webpack_public_path__ + "static/media/secietypic03@2x.92c15f4d.png";